// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore }  from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBxh2GJynUmtCIAbLWG3GriG_lC8GJHwFs",
  authDomain: "numberland-55.firebaseapp.com",
  databaseURL: "https://numberland-55-default-rtdb.firebaseio.com",
  projectId: "numberland-55",
  storageBucket: "numberland-55.appspot.com",
  messagingSenderId: "876778655981",
  appId: "1:876778655981:web:3fa7dee3a0d5cc87853ce4",
  measurementId: "G-6ZGZZTEB64"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export default db; 